import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-number-input',
	templateUrl:'./WaNumberInputPage.html',
	styles: [],
	styleUrls:['./WaNumberInputPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaNumberInputPage
{
	mdContent_378 = `\`\`\`java
import com.jwebmp.webawesome.components.numberinput.WaNumberInput;
\`\`\``;
	mdContent_379 = `\`\`\`java
var num = new WaNumberInput<>();
num.setLabel("Quantity");
num.setMin(1);
num.setMax(99);
num.setStep(1);
\`\`\``;
}
